'use memo';

import { createRefreshPollingStore } from '@/lib/assignment-refresh-polling/createRefreshPollingStore';
const REFRESH_POLLING_DURATION_MS = 60_000;

/**
 * Device 割り当てルール／アラートの refresh 追従ポーリングを一定時間だけブーストするストア。
 *
 * ルール・Device Group・People Group・Device 操作など、複数ドメインの mutation 後に
 * 60 秒だけ関連クエリのポーリングを短間隔化する横断的な関心事のため、特定の feature 配下
 * ではなく中立な lib 層に置く（`features/A ↛ features/B` の直接依存を避けるため）。
 */
export const useDeviceAssignmentRefreshPollingStore = createRefreshPollingStore({
  durationMs: REFRESH_POLLING_DURATION_MS
});
export function startDeviceAssignmentRefreshPolling(): void {
  useDeviceAssignmentRefreshPollingStore.getState().startBoost();
}
export function useDeviceAssignmentRefreshPollingBoosting(): boolean {
  return useDeviceAssignmentRefreshPollingStore(state => state.isBoosting);
}